import { render, staticRenderFns } from "./SnackAlerta.vue?vue&type=template&id=a486ac22&"
import script from "./SnackAlerta.vue?vue&type=script&lang=ts&"
export * from "./SnackAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports